"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instanceOf = instanceOf;

var _debrief = require("debrief");

var _Result = require("lemons/Result");

function instanceOf(klass) {
  return function (blob) {
    return blob instanceof klass ? (0, _Result.Ok)(blob) : (0, _Result.Err)((0, _debrief.annotate)(blob, "Must be ".concat( // $FlowFixMe[incompatible-use] - klass.name is fine?
    klass.name, " instance")));
  };
}